import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { SharedAlertData } from '../../components/modals/alert-data.model';
import { SharedAlertModalComponent } from '../../components/modals/alert-modal.component';
import { SharedConfirmData } from '../../components/modals/confirmation-data.model';
import { SharedConfirmationModalComponent } from '../../components/modals/confirmation-modal.component';
import { SharedWarningData } from '../../components/modals/warning-data.model';
import { SharedWarningModalComponent } from '../../components/modals/warning-modal.component';
import { ModalSize } from './mvd-modal.enum';
import { MvdScrollStrategy } from './scroll-strategy/mvdscroll-strategy.class';

@Injectable()
export class MvdModalService {

    constructor(private dialog: MatDialog, private scrollStrategy: MvdScrollStrategy) {}

    // supports API chaining to create alert modal
    alert() {
        return new SharedAlertData(this);
    }

    alertModal(data: SharedAlertData, modalSize?: ModalSize) {
        return this.open(SharedAlertModalComponent, data, modalSize);
    }

    // supports API chaining to create confirm modal
    confirm() {
        return new SharedConfirmData(this);
    }

    confirmModal(data: SharedConfirmData, modalSize?: ModalSize) {
        return this.open(SharedConfirmationModalComponent, data, modalSize);
    }

    // open component in modal, passing in data, and to size or with specific classes on modal container
    open(component: any, data?: any, addClass?: string[] | ModalSize): MatDialogRef<any> {
        let panelClass = Array.isArray(addClass) ? addClass : [addClass];
        const config = Object.assign({}, {
            scrollStrategy: this.scrollStrategy,
            ...(data && {data: data}),
            ...(addClass && {panelClass: ['modal-dialog', ...panelClass]})
        });
        return this.dialog.open(component, config);
    }

    // supports API chaining to create warning modal
    warning() {
        return new SharedWarningData(this);
    }

    warningModal(data: SharedWarningData, modalSize?: ModalSize) {
        return this.open(SharedWarningModalComponent, data, modalSize);
    }

    closeAll() {
        this.dialog.closeAll();
        this.scrollStrategy.reset();
    }
}
